module.exports = __webpack_public_path__ + "media/images/twitter/twitter_configuration-b00440a9c68120a15d25e47a757817e6.png";